/**
 * Convert string to number.
 * @param entry
 * @return number
 */

export const convertStringToNumber = (entry: string): number => {
  const _entry = entry.replaceAll(',', '.')
  return parseFloat(_entry) ? parseFloat(_entry) : 0
}
